var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "set-up flex flex-column items-center",
      attrs: { "element-loading-text": _vm.loadText }
    },
    [
      _c("Agreement", {
        attrs: { visible: _vm.agreementVisible },
        on: {
          "update:visible": function($event) {
            _vm.agreementVisible = $event
          }
        }
      }),
      _c(
        "div",
        { staticClass: "mar60-b w800" },
        [
          _c(
            "el-steps",
            { attrs: { active: _vm.shopActive, "align-center": "" } },
            [
              _c("el-step", { attrs: { title: "提交申请" } }),
              _c("el-step", { attrs: { title: "资质审核" } }),
              _c("el-step", { attrs: { title: "支服务费&保证金" } }),
              _c("el-step", { attrs: { title: "开店成功" } })
            ],
            1
          )
        ],
        1
      ),
      !_vm.shopId
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("div", { staticClass: "c-FF9500 pad10-tb" }, [
                _vm._v(
                  "温馨提示：支付店铺保证金时需用企业账户余额进行支付，请提前进行充值"
                )
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.toBalance }
                },
                [_vm._v("去充值")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.shopInfo.isDepositPaid === 1
        ? _c("div", { staticClass: "text-center" }, [
            _c("i", { staticClass: "el-icon-success f40 c-00C700" }),
            _c("div", { staticClass: "f18 c-00C700 pad10-t" }, [
              _vm._v("你的平台服务/保证金已支付完成")
            ]),
            _c("div", { staticClass: "f18 c-00C700" }, [
              _vm._v("店铺已自动开通")
            ]),
            _c(
              "div",
              { staticClass: "text-center mar60-t" },
              [
                _c(
                  "el-button",
                  { attrs: { plain: "" }, on: { click: _vm.toTrade } },
                  [_vm._v("去看看")]
                )
              ],
              1
            )
          ])
        : [
            _c(
              "div",
              { staticClass: "pad40-b text-center" },
              [
                _vm.shopInfo.qualificationStatus === 0
                  ? [
                      _c("img", {
                        attrs: { src: require("./images/audit-icon.png") }
                      }),
                      _c("div", { staticClass: "f18 c-FF9500 pad10-t" }, [
                        _vm._v("店铺资质正在审核中")
                      ]),
                      _vm.orgStatus !== 8
                        ? [
                            _c("div", { staticClass: "c-FF9500 pad10-tb" }, [
                              _vm._v(
                                "若您的企业还未认证，请点击【去认证】完成企业认证后才能审核通过"
                              )
                            ]),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "small" },
                                on: { click: _vm.orgAut }
                              },
                              [_vm._v("去认证")]
                            )
                          ]
                        : _vm._e()
                    ]
                  : _vm._e(),
                _vm.shopInfo.qualificationStatus === 1
                  ? [
                      !_vm.shopInfo.isDepositPaid
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("./images/success-icon.png")
                              }
                            }),
                            _c(
                              "div",
                              { staticClass: "f18 c-00C700 pad10-tb" },
                              [_vm._v("资质审核已通过")]
                            ),
                            _c("div", { staticClass: "c-00C700" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.shopInfo.contractId
                                      ? "请签署/确认合同后支付开店所需的平台服务费或保证金"
                                      : "未获取到关联合同，请联系运营人员配置合同"
                                  ) +
                                  "\n          "
                              )
                            ])
                          ]
                        : _vm._e(),
                      _c("div", { staticClass: "pay-main pad20 mar40-t" }, [
                        _c("div", { staticClass: "text-left" }, [
                          _vm._v("请线上签署农信平台招商协议后支付以下费用")
                        ]),
                        _c(
                          "div",
                          { staticClass: "f16 mar20-t flex justify-center" },
                          [
                            _c("div", { staticClass: "flex flex-column" }, [
                              _c("div", { staticClass: "mar5-b flex" }, [
                                _c("span", { staticClass: "gray9" }, [
                                  _vm._v("平台服务费：")
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.shopInfo.shopServiceAmount) +
                                      "元"
                                  )
                                ])
                              ]),
                              _vm.shopInfo.isDepositRequired
                                ? _c("div", { staticClass: "mar5-b flex" }, [
                                    _c("span", { staticClass: "gray9" }, [
                                      _vm._v("保证金：")
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.shopInfo.shopDeposit) + "元"
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "flex" }, [
                                _c("span", { staticClass: "gray9" }, [
                                  _vm._v("总支付金额：")
                                ]),
                                _c("span", { staticClass: "c-FF9500" }, [
                                  _vm._v(
                                    _vm._s(_vm.shopInfo.totalAmount) + "元"
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "pad60-lr mar60-t" }, [
                        _vm.shopInfo.contractId &&
                        (_vm.shopInfo.shopServiceAmount ||
                          _vm.shopInfo.shopDeposit)
                          ? _c(
                              "div",
                              {
                                staticClass: "flex items-center justify-between"
                              },
                              [
                                _vm.shopInfo.contractId
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { plain: "" },
                                        on: { click: _vm.signContract }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.shopInfo
                                                .contractSignStatus === 0
                                                ? "签署合同"
                                                : "查看合同"
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.shopInfo.shopServiceAmount ||
                                _vm.shopInfo.shopDeposit
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.toPay }
                                      },
                                      [_vm._v("去支付")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "flex items-center justify-center"
                              },
                              [
                                _vm.shopInfo.contractId
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { plain: "" },
                                        on: { click: _vm.signContract }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.shopInfo
                                                .contractSignStatus === 0
                                                ? "签署合同"
                                                : "查看合同"
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.shopInfo.shopServiceAmount ||
                                _vm.shopInfo.shopDeposit
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.toPay }
                                      },
                                      [_vm._v("去支付")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                        (_vm.shopInfo.shopServiceAmount ||
                          _vm.shopInfo.shopDeposit) &&
                        _vm.shopInfo.contractId
                          ? _c(
                              "div",
                              { staticClass: "text-left mar10-t" },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value: _vm.conChecked,
                                      callback: function($$v) {
                                        _vm.conChecked = $$v
                                      },
                                      expression: "conChecked"
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "c-FF9500" }, [
                                      _vm._v("我已知晓并确认合同内容")
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ]
                  : _vm._e(),
                _vm.shopInfo.qualificationStatus === 2
                  ? [
                      _c("img", {
                        attrs: { src: require("./images/reject-icon.png") }
                      }),
                      _c("div", { staticClass: "f18 c-E01212 pad10-t" }, [
                        _vm._v("申请被驳回")
                      ]),
                      _c("div", { staticClass: "c-E01212" }, [
                        _vm._v("驳回原因：" + _vm._s(_vm.shopInfo.rejectReason))
                      ])
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm.shopInfo.qualificationStatus !== 1
              ? _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.ruleForm,
                      rules: _vm.rules,
                      "label-width": "150px",
                      "label-suffix": "："
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "店铺名称", prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请为您的店铺起个名称",
                            disabled: _vm.shopInfo.qualificationStatus === 0
                          },
                          model: {
                            value: _vm.ruleForm.name,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "name", $$v)
                            },
                            expression: "ruleForm.name"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "经营类型",
                          required: "",
                          error: _vm.error.bus
                        }
                      },
                      [
                        _c("el-cascader", {
                          attrs: {
                            options: _vm.busTypeTree,
                            props: _vm.props,
                            "collapse-tags": "",
                            clearable: "",
                            placeholder: "请选择店铺经营类型",
                            disabled: _vm.shopInfo.qualificationStatus === 0
                          },
                          model: {
                            value: _vm.busList,
                            callback: function($$v) {
                              _vm.busList = $$v
                            },
                            expression: "busList"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "所在地区", required: "" } },
                      [
                        _c("el-cascader", {
                          attrs: {
                            value: _vm.areaValue,
                            props: _vm.area,
                            disabled: _vm.shopInfo.qualificationStatus === 0
                          },
                          on: { change: _vm.areaChange }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "详细地址", prop: "addr" } },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: _vm.shopInfo.qualificationStatus === 0
                          },
                          model: {
                            value: _vm.ruleForm.addr,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "addr", $$v)
                            },
                            expression: "ruleForm.addr"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "联系方式", prop: "tel" } },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: _vm.shopInfo.qualificationStatus === 0
                          },
                          model: {
                            value: _vm.ruleForm.tel,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "tel", $$v)
                            },
                            expression: "ruleForm.tel"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "服务人员" } },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: "5",
                            disabled: _vm.shopInfo.qualificationStatus === 0
                          },
                          model: {
                            value: _vm.ruleForm.boIdServicePersonalName,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.ruleForm,
                                "boIdServicePersonalName",
                                $$v
                              )
                            },
                            expression: "ruleForm.boIdServicePersonalName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "上传经营资质",
                          required: "",
                          error: _vm.error.img
                        }
                      },
                      [
                        _vm.shopInfo.qualificationStatus === 0
                          ? _c(
                              "div",
                              _vm._l(_vm.photoList, function(item, index) {
                                return _c("img", {
                                  key: index,
                                  staticClass: "update-img",
                                  attrs: { src: item.url }
                                })
                              }),
                              0
                            )
                          : _c(
                              "el-upload",
                              {
                                staticClass: "mar10-b",
                                attrs: {
                                  limit: 5,
                                  action:
                                    _vm.env.VUE_APP_fileserver +
                                    "persistentUpload",
                                  "file-list": _vm.photoList,
                                  "list-type": "picture-card",
                                  "on-success": _vm.uploadSuccess,
                                  "before-upload": _vm.uploadBefore,
                                  "on-remove": _vm.uploadRemove
                                }
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-plus avatar-uploader-icon"
                                })
                              ]
                            ),
                        _c(
                          "div",
                          {
                            staticClass: "blue pointer",
                            on: { click: _vm.pdfLink }
                          },
                          [_vm._v("上传说明")]
                        )
                      ],
                      1
                    ),
                    _vm.shopInfo.qualificationStatus !== 0
                      ? [
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.checked,
                                    callback: function($$v) {
                                      _vm.checked = $$v
                                    },
                                    expression: "checked"
                                  }
                                },
                                [_vm._v("我已阅读并同意 ")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "c-FF9500 pointer",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      _vm.agreementVisible = true
                                    }
                                  }
                                },
                                [_vm._v("《农信平台用户协议》")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.submitForm }
                                },
                                [_vm._v("免费开店")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "mar60-l",
                                  attrs: { plain: "" },
                                  on: { click: _vm.resetForm }
                                },
                                [_vm._v("取消")]
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }